import { Page } from 'components/Page'
import { RewardProgramDetailHeader } from './RewardProgramDetailHeader'
import { useNavigate, useParams } from 'react-router-dom'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import {
  Box,
  MenuItem,
  Select,
  type SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material'
import { useGetRewardProgramById } from 'hooks/api/useGetRewardProgramById'
import { RedemptionSection } from './RedemptionSection'
import { useEffect, useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { colorPrimitives } from 'components/Theme'
import { useCurrentCorporateAccountStore } from 'stores/useCurrentCorporateAccountStore'

export const RewardProgramRedemptionPage = () => {
  const { id: rewardProgramId } = useParams()
  const navigate = useNavigate()
  const selectedCorporateAccountId =
    useCurrentCorporateAccountStore().currentCorporateAccountId
  const [tableDaysDisplayed, setTableDaysDisplayed] = useState<number>(30)

  const handleChange = (event: SelectChangeEvent) => {
    setTableDaysDisplayed(Number(event.target.value))
  }

  const rewardProgramQuery = useGetRewardProgramById({
    rewardProgramId,
  })

  useEffect(() => {
    // If the CA is switched and the new CA does not match then navigate back to the list page
    if (
      rewardProgramQuery.data?.corporateAccountId !== null &&
      rewardProgramQuery.data?.corporateAccountId !== undefined &&
      rewardProgramQuery.data?.corporateAccountId !== selectedCorporateAccountId
    ) {
      void navigate('/Rewards')
    }
  }, [rewardProgramQuery.data])

  if (rewardProgramQuery.isPending) {
    return <ActivityIndicator />
  }

  if (rewardProgramQuery.isError) {
    return <p>An error occurred.</p>
  }

  return (
    <Page
      header={
        <RewardProgramDetailHeader
          rewardProgram={rewardProgramQuery.data}
          currentTab={`/RewardsProgram/${rewardProgramId}/Redemption`}
        />
      }
    >
      <Stack spacing={'24px'}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            justifyContent: { xs: 'start', sm: 'space-between' },
            alignItems: { xs: 'start', sm: 'center' },
            rowGap: '8px',
          }}
        >
          <Box>
            <Typography variant="h3">Reward Redemptions</Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              'svg path': {
                fill: colorPrimitives.redGaming,
              },
            }}
          >
            <Select
              value={String(tableDaysDisplayed)}
              onChange={handleChange}
              displayEmpty
              sx={{
                padding: '0px 0px 0px 0px !important',
                boxShadow: 'none',
                '.MuiOutlinedInput-notchedOutline': {
                  border: 'none !important',
                },
                '.Mui-focused': { border: 'none !important' },
                color: colorPrimitives.redGaming,
              }}
              IconComponent={KeyboardArrowDownIcon}
            >
              <MenuItem value={7}>Last 7 Days</MenuItem>
              <MenuItem value={30}>Last 30 Days </MenuItem>
              <MenuItem value={90}>Last 3 Months</MenuItem>
              <MenuItem value={365}>Year to Date</MenuItem>
            </Select>
          </Box>
        </Box>
        <RedemptionSection
          rewardProgramId={Number(rewardProgramId)}
          daysDisplayed={tableDaysDisplayed}
        />
      </Stack>
    </Page>
  )
}
